import {
  formatCPF,
  formatCNPJ,
  PIX_ALEATORIA_OPTION,
  PIX_CNPJ_OPTION,
  PIX_CPF_OPTION,
  PIX_EMAIL_OPTION,
  PIX_TELEFONE_OPTION,
  formatTelefone,
  TIPO_CONTATO_TELEFONE,
} from '../../../utils';

function getValorFormatado(valor, type) {
  switch (type) {
    case PIX_CNPJ_OPTION:
      return formatCNPJ(valor);
    case PIX_CPF_OPTION:
      return formatCPF(valor);
    case PIX_TELEFONE_OPTION:
      return formatTelefone(valor);
    default:
      return valor;
  }
}

function getLabelTipo(type) {
  switch (type) {
    case PIX_CNPJ_OPTION:
      return 'CNPJ';
    case PIX_CPF_OPTION:
      return 'CPF';
    case PIX_TELEFONE_OPTION:
      return 'Telefone';
    case PIX_EMAIL_OPTION:
      return 'Email';
    case PIX_ALEATORIA_OPTION:
      return 'Aleatória';
    default:
      return '';
  }
}

function getValorFormatadoContato(valor, type) {
  switch (type) {
    case TIPO_CONTATO_TELEFONE:
      return formatTelefone(valor);
    default:
      return valor;
  }
}

function getLabelTipoContato(type) {
  switch (type) {
    case TIPO_CONTATO_TELEFONE:
      return 'Telefone';
    default:
      return '';
  }
}

export {
  getValorFormatado,
  getLabelTipo,
  getValorFormatadoContato,
  getLabelTipoContato,
};
